import { push } from "connected-react-router";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { currentAgentApplicationSelector } from "../../redux/selector/collectorApplicationSelector";
import { 
  ROUTE_PATH, 
  LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION, 
  APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE,
  APPLICATION_MODE_NEW
} from "../../app/constants";
import { Button } from "../../components/RegularComponents";
import TopNavigationBar from "../TopNavigationBar";

export const IsResidentOfCanadaQuestionView = (props) => {
  const dispatch = useDispatch();

  const agentApplication = useSelector(currentAgentApplicationSelector);
  const licencingSubType = agentApplication ? agentApplication.licencingSubType : LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION
  const isPrincipalBroker = licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION;

  const title =
  !isPrincipalBroker
    ? "Is the applicant a resident of Canada?"
    : "Are you a resident of Canada?";

  const { MRA_BROKER_ASSOCIATE = false } = { ...props.location?.state };

  const handleNext = (isResidentOfCanada) => () => {

    const nextPath = isResidentOfCanada
      ? ROUTE_PATH.MRA_IS_NINETEEN
      : ROUTE_PATH.MRA_IS_CANADA_RESIDENT_NO;

    dispatch(
      push({
        pathname: `${ROUTE_PATH.MRA_APP}${nextPath}`,
        state: { MRA_BROKER_ASSOCIATE },
      })
    );
  };

  return (
    <div className="container">
      <TopNavigationBar 
          {...props} 
          applicationType={APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE} 
          applicationMode={APPLICATION_MODE_NEW} 
      />
      {/* Title */}
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h1>{title}</h1>
        </div>
      </div>

      {/* Yes/No Answer */}
      <div className="row">
        <div className="col-lg-2 ">
          <Button
            className={"ns-btn-yes-no btn-default"}
            buttonType="primary_regular"
            onClick={handleNext(true)}
            text={"Yes"}
          />
        </div>

        <div className="col-lg-3">
          <Button
            className={"ns-btn-yes-no btn-default"}
            buttonType="primary_regular"
            onClick={handleNext(false)}
            value={false}
            text={"No"}
          />
        </div>
      </div>
    </div>
  );
};
